export default __webpack_public_path__ + "static/media/CBBComedorD.ebc40eb5.jpg";